import {parseMessage} from 'lib/stringHelper';

export const FormControl = {
  USERNAME: {
    LABEL_HEADER: 'Username',
    TYPE: 'input',
    INPUT_TYPE: 'text',
    PLACEHOLDER: 'Username',
    GLYPH: 'Users',
    FIELD_KEY: 'USERNAME',
  },
  PASSWORD: {
    LABEL_HEADER: 'Password',
    TYPE: 'input',
    INPUT_TYPE: 'password',
    PLACEHOLDER: 'Password',
    FIELD_KEY: 'PASSWORD',
  },
  NAME: {
    LABEL_HEADER: 'Name',
    TYPE: 'input',
    INPUT_TYPE: 'text',
    PLACEHOLDER: 'Name',
    FIELD_KEY: 'NAME',
  },
  EMAIL: {
    LABEL_HEADER: 'Email',
    TYPE: 'input',
    INPUT_TYPE: 'text',
    PLACEHOLDER: 'e-mail',
    GLYPH: 'Email',
    FIELD_KEY: 'EMAIL',
  },
  ACCESS_ROLE: {
    LABEL_HEADER: 'Role',
    TYPE: 'dropdown',
    PLACEHOLDER: 'Select Role',
    VALUE_KEY: 'id',
    LABEL_KEY: 'name',
    FIELD_KEY: 'ACCESS_ROLE',
  },
  ACTIVE: {
    LABEL: parseMessage('userManagement.addEditModal.active.label'),
    LABEL_INACTIVE: parseMessage('userManagement.addEditModal.inactive.label'),
    HINT_INACTIVE: parseMessage('userManagement.addEditModal.inactive.hint'),
    TYPE: 'checkbox',
    FIELD_KEY: 'ACTIVE',
  },
  OLD_PASSWORD: {
    LABEL_HEADER: 'Old Password',
    TYPE: 'input',
    INPUT_TYPE: 'password',
    PLACEHOLDER: 'Password',
    FIELD_KEY: 'OLD_PASSWORD',
  },
  NEW_PASSWORD: {
    LABEL_HEADER: 'New Password',
    TYPE: 'input',
    INPUT_TYPE: 'password',
    PLACEHOLDER: 'Password',
    FIELD_KEY: 'NEW_PASSWORD',
  },
  CONFIRM_NEW_PASSWORD: {
    LABEL_HEADER: 'Confirm New Password',
    TYPE: 'input',
    INPUT_TYPE: 'password',
    PLACEHOLDER: 'Password',
    FIELD_KEY: 'CONFIRM_NEW_PASSWORD',
  },
  CONFIRM_PASSWORD: {
    LABEL_HEADER: 'Confirmation Password',
    TYPE: 'input',
    INPUT_TYPE: 'password',
    PLACEHOLDER: 'Password',
    FIELD_KEY: 'CONFIRM_PASSWORD',
  },
};

export const AlertType = {
  USERNAME: 'username',
  PASSWORD: 'password',
  OLD_PASSWORD: 'old_password',
  NEW_PASSWORD: 'new_password',
  CONFIRM_NEW_PASSWORD: 'confirm_new_password',
  CONFIRM_PASSWORD: 'confirm_password',
  EMAIL: 'email',
};

export const AlertUsername = {
  USERNAME_EXIST: 'usernameExist',
  SAME_WITH_PASSWORD: 'sameWithPassword',
};

export const AlertPassword = {
  TOO_SHORT: 'tooShort',
  SAME_WITH_USERNAME: 'sameWithUsername',
  MUST_CONTAIN_FORMAT: 'mustContainFormat',
  CONFIRM_PASSWORD_NOT_MATCH: 'confirmPasswordNotSame',
  OLD_PASSWORD_NOT_MATCH: 'oldPasswordNotSame',
  SAME_WITH_OLD_PASSWORD: 'sameWithOldPassword',
};

export const AlertEmail = {
  EMAIL_NOT_VALID: 'emailNotValid',
  EMAIL_ALREADY_EXIST: 'emailAlreadyExist',
};

export const ValidatePassword = {
  TOO_SHORT: 'tooShort',
  SAME_WITH_USERNAME: 'sameWithUsername',
  MUST_CONTAIN_FORMAT: 'mustContainFormat',
};

export const ValidateResult = {
  FAILED: 0,
  SUCCESS: 1,
  USERNAME_ALREADY_EXIST: 2,
  EMAIL_ALREADY_EXIST: 3,
  USER_NOT_FOUND: 4,
  DOES_NOT_HAVE_PRIVILAGE: 5,
};
